import { useNavigate, useRevalidator } from 'react-router';
import { SimType } from '../../generated/api/simType';
import { closeDialog, setDialogSubmitFailed, setDialogSubmitting } from '../../public/site/dialogStore';
import { addNotification } from '../../public/site/notificationStore.js';
import { paths } from '../constants/pathVariables';
import { postChangeSim } from '../fetch';
import { t } from '../i18n';
import { CATEGORY_URL } from '../utils/categoryUtils';
import { useSearchParams } from './useSearchParams';
import type { ChangeMobileSimParameters } from '../../generated/api/changeMobileSimParameters';
import type { DeliveryAddress } from '../../generated/api/deliveryAddress';
import type { Subscription } from '../../generated/api/subscription';
import type { CategoryKey } from '../utils/categoryUtils';

const getChangeSimMessage = (simType: SimType, isDelivery = false): string => {
  if (simType === SimType.ESIM) {
    return t.DNMO('Thank you! eSIM order submitted successfully.');
  } else if (isDelivery) {
    return t.RTNX('Order shipped successfully');
  }
  return t.XUMF('SIM card activated successfully.');
};

export const useChangeSim = (sub: Subscription, isEoe: boolean) => {
  const navigate = useNavigate();
  const { revalidate } = useRevalidator();
  const { mdmId } = useSearchParams<{ mdmId: string }>();

  return async (simType: SimType, category: CategoryKey, simCardNumber?: string, deliveryAddress?: DeliveryAddress) => {
    try {
      const payload: ChangeMobileSimParameters = {
        simType: simType,
        iccId: simCardNumber,
        deliveryAddress: deliveryAddress,
      };

      setDialogSubmitting(true);
      await postChangeSim(sub.subscriptionId, payload, mdmId);
      addNotification(getChangeSimMessage(simType, !!deliveryAddress));
      closeDialog();
      const path = isEoe
        ? `${paths.EMPLOYEE_HOME}/${CATEGORY_URL[category]}/${sub.subscriptionId}`
        : `${paths.PS_HOME}/${CATEGORY_URL[category]}/${sub.subscriptionDisplayId}${mdmId ? `?mdmId=${mdmId}` : ''}`;
      navigate(path);
      void revalidate(); // Update pendingSubActions, so the sub is shown as pending.
    } catch {
      setDialogSubmitFailed();
    }
  };
};
